/**
 * Router for the marketing landing site.
 */
import { createRouter, createWebHistory } from 'vue-router';
import { ROUTE_SEO } from '../config/seo.js';

const HomePage = () => import('../pages/HomePage.vue');
const FeaturesPage = () => import('../pages/FeaturesPage.vue');
const PricingPage = () => import('../pages/PricingPage.vue');
const FaqPage = () => import('../pages/FaqPage.vue');
const LegalPage = () => import('../pages/LegalPage.vue');

export const router = createRouter({
  history: createWebHistory(),
  scrollBehavior(to, _from, saved) {
    if (saved) return saved;
    if (to.hash) return { el: to.hash, behavior: 'smooth', top: 80 };
    return { left: 0, top: 0 };
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomePage,
      meta: ROUTE_SEO.home,
    },
    {
      path: '/features',
      name: 'features',
      component: FeaturesPage,
      meta: ROUTE_SEO.features,
    },
    {
      path: '/pricing',
      name: 'pricing',
      component: PricingPage,
      meta: ROUTE_SEO.pricing,
    },
    { path: '/faq', name: 'faq', component: FaqPage, meta: ROUTE_SEO.faq },
    {
      path: '/legal',
      name: 'legal',
      component: LegalPage,
      meta: ROUTE_SEO.legal,
    },
    { path: '/:pathMatch(.*)*', redirect: '/' },
  ],
});
